import React from 'react';
import { Section } from '../components/Section';
import { SubHeading } from '../components/typography/SubHeading';
import { Button, ButtonVariant } from '../components/button/Button';
import styled from 'styled-components';
import { Heading } from '../components/typography/Heading';
import { contactInfo } from '../config/navigation';

const Container = styled.div`
  margin-left: 6rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 0 1rem;
    margin-left: 0;
  }
`;

const StyledSubHeading = styled(SubHeading)`
  color: #6f8098;
  margin-bottom: 1rem;
  font-size: 1rem;
  letter-spacing: 0.5px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 12px;
  }
`;

const HeadingContainer = styled.div`
  margin-bottom: 1.5rem;
`;

const MainHeading = styled(Heading)`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 2.5rem;
  margin-bottom: 0;
  margin-top: 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 1.5rem;
  }
`;

const EmphasisText = styled.span`
  font-style: italic;
`;

const Description = styled.p`
  color: #6f8098;
  max-width: 600px;
  line-height: 1.6;
  margin-bottom: 3rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 14px;
    margin-bottom: 1rem;
  }
`;

const CallToActionBox = styled.div`
  background: linear-gradient(101.46deg, #1a3156 0%, #294e89 100%);
  border-radius: 10px;
  padding: 2rem;
  max-width: 90%;
`;

const CallToActionText = styled.h3`
  color: ${({ theme }) => theme.colors.white};
  margin-bottom: 1.5rem;
  font-size: 1.5rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 18px;
  }
`;

export const ConnectUs: React.FC = () => {
  const handleClick = () => {
    // Track metrics
    console.log("Let's connect button clicked from ConnectUs section");

    window.location.href = `https://wa.me/${contactInfo.phoneNumber}`;
  };

  return (
    <Section>
      <Container>
        <StyledSubHeading>CONNECT</StyledSubHeading>
        <HeadingContainer>
          <MainHeading>
            We&apos;re your <EmphasisText>partners </EmphasisText>
            in a shared vision.
          </MainHeading>
        </HeadingContainer>
        <Description>
          Connect with our financial advisor who puts you and your needs first. Make the call that could change your
          life for the better today.
        </Description>
        <CallToActionBox>
          <CallToActionText>Ready to Start Your Investment Journey?</CallToActionText>
          <Button variant={ButtonVariant.Secondary} onClick={handleClick}>
            Let&apos;s talk
          </Button>
        </CallToActionBox>
      </Container>
    </Section>
  );
};
